// extracted by mini-css-extract-plugin
export var root = "index-module--root--84a4d";
export var navContainer = "index-module--navContainer--b967e";
export var blogsContainer = "index-module--blogsContainer--dd2f8";
export var loadMoreContainer = "index-module--loadMoreContainer--b0183";